/**
 * Short "3m ago" / "2h ago" / "yesterday" / "Mar 5" formatter.
 * Used across parent, public, and classroom views.
 */
export function timeAgo(iso) {
  if (!iso) return "";
  const then = new Date(iso);
  const now = new Date();
  const minutes = Math.floor((now - then) / 60000);
  if (minutes < 1) return "just now";
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days === 1) return "yesterday";
  if (days < 7) return `${days}d ago`;
  return then.toLocaleDateString("en-CA", { month: "short", day: "numeric" });
}

/**
 * Returns "1st", "2nd", "3rd", "4th", etc.
 */
export function ordinal(n) {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}
